module.exports = __webpack_public_path__ + "static/media/ChildRoomDesigner.2cd00688.jpg";